const colors = {
  primary: '#ff6a0e',
  primary_dark: '#d75200',
  primary_light: '#ff8c5a',
  primary_lighter: '#fdd3c2',
  secondary: '#6048fd',
  secondary_dark: '#181532',
  secondary_light: '#E7E3FF',
  secondary_lighter: '#f3f2fb',
  tertiary: '#c08e6b',
  tertiary_light: '#c9b9ad',
  tertiary_lighter: '#fef8f4',
  quaternary: '#ff6363',
  quaternary_dark: '#86242e',
  quaternary_light: '#fc9494',
  quaternary_lighter: '#fbe4e4',
  quinary_dark: '#17547c',
  quinary: '#d5ecfc',
  quinary_light: '#eff2fd',
  quinary_lighter: '#f9fbff',
  neutral_900: '#1a1918',
  neutral_800: '#333130',
  neutral_700: '#4d4a48',
  neutral_600: '#666260',
  neutral_500: '#807b78',
  neutral_400: '#999390',
  neutral_300: '#b3aca8',
  neutral_200: '#ccc4c0',
  neutral_100: '#f2ece8',
  neutral_80: '#f2f2f2',
  neutral_60: '#f8f8f8',
  neutral_50: '#fffdfc',
  neutral_25: '#fff',
  neutral_0: 0xff000000,
  error: '#ff6363',
  success: '#00aeb3',
  warning: '#ffbc2f',
  warning_dark: '#d7a029',
  info: '#22cb3c',
};
export default defineNuxtPlugin(() => {
  return {
    provide: {
      colors,
    },
  };
});
